import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Headers from './dashboardComponents/headers';
//import ChatMenu from './ChatMenu';
import AddNotes from  './idiaryPages/addNote';
import EditNotes from  './idiaryPages/editNote';
import AllNotes from './idiaryPages/allNotes';
import SearchedNotes from './idiaryPages/searchedNotes'

class Idiary extends Component {

  render() {

  	
    return (
    	<Router>
          <div className="chat-message-container" id="user-msg-container">
						<div className="dashboard-feature-container">
							<Headers 
								text="iDiary"
								img = {null}
								display = "hide"
								leave = {null} 
								view = {null}
								mute = {null} 
								search = {null}
								report = {null}
							/>
							
							<Switch>
								<Route exact path="/dashboard/idiary/" component={AllNotes} />
								<Route exact path="/dashboard/idiary/addnote" component={AddNotes} />
								<Route exact path="/dashboard/idiary/editnote/:ID" component={EditNotes} />
								<Route exact path="/dashboard/idiary/searchresults/:search" component={SearchedNotes} />              
							</Switch>	
						
						</div>
					</div>
	      
			</Router>
    )
  }
}


export default Idiary;